import { type StationNetworkConfig } from 'src/types';
import stationNetworkConfigs, {
  type CreateStationNetworkConfigRequest,
} from '../../api/stationNetworkConfigs';
import { type AppDispatch } from '../store';

export const GET_STATION_NETWORK_CONFIGS_SUCCESS = 'GET_STATION_NETWORK_CONFIGS_SUCCESS';
export const GET_STATION_NETWORK_CONFIGS_FAILURE = 'GET_STATION_NETWORK_CONFIGS_FAILURE';

export const GET_STATION_NETWORK_OPTIONS_SUCCESS = 'GET_STATION_NETWORK_OPTIONS_SUCCESS';
export const GET_STATION_NETWORK_OPTIONS_FAILURE = 'GET_STATION_NETWORK_OPTIONS_FAILURE';

export const CREATE_STATION_NETWORK_CONFIG_SUCCESS = 'CREATE_STATION_NETWORK_CONFIG_SUCCESS';
export const CREATE_STATION_NETWORK_CONFIG_FAILURE = 'CREATE_STATION_NETWORK_CONFIG_FAILURE';

export const REMOVE_STATION_NETWORK_CONFIG_SUCCESS = 'REMOVE_STATION_NETWORK_CONFIG_SUCCESS';
export const REMOVE_STATION_NETWORK_CONFIG_FAILURE = 'REMOVE_STATION_NETWORK_CONFIG_FAILURE';

export const getStationNetworkConfigs = (stationId: number) => async (dispatch: AppDispatch) =>
  await stationNetworkConfigs
    .get(stationId)
    .then((networkConfigs) =>
      dispatch({
        type: GET_STATION_NETWORK_CONFIGS_SUCCESS,
        data: networkConfigs,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_STATION_NETWORK_CONFIGS_FAILURE,
        data: err,
      })
    );

export const getStationNetworkOptions = (stationId: number) => async (dispatch: AppDispatch) =>
  await stationNetworkConfigs
    .getNetworkOptions(stationId)
    .then((networkOptions) =>
      dispatch({
        type: GET_STATION_NETWORK_OPTIONS_SUCCESS,
        data: networkOptions,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_STATION_NETWORK_OPTIONS_FAILURE,
        data: err,
      })
    );

export const createStationNetworkConfig =
  (stationId: number, networkConfig: CreateStationNetworkConfigRequest) =>
  async (dispatch: AppDispatch) =>
    await stationNetworkConfigs
      .create(stationId, networkConfig)
      .then(() =>
        dispatch({
          type: CREATE_STATION_NETWORK_CONFIG_SUCCESS,
        })
      )
      .then(async () => await dispatch(getStationNetworkConfigs(stationId)))
      .catch((err) =>
        dispatch({
          type: CREATE_STATION_NETWORK_CONFIG_FAILURE,
          data: err,
        })
      );

export const deleteStationNetworkConfig =
  (networkConfig: StationNetworkConfig) => async (dispatch: AppDispatch) =>
    await stationNetworkConfigs
      .remove(networkConfig.stationId, networkConfig.stationNetworkConfigId)
      .then(() =>
        dispatch({
          type: REMOVE_STATION_NETWORK_CONFIG_SUCCESS,
        })
      )
      .then(async () => await dispatch(getStationNetworkConfigs(networkConfig.stationId)))
      .catch((err) =>
        dispatch({
          type: REMOVE_STATION_NETWORK_CONFIG_FAILURE,
          data: err,
        })
      );
